import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { MGrid, MSplitter } from "components/Shared";
import { searchEmployees } from "requests/employee";
import { getSearchParameter } from "components/Shared/Functions";
import EmployeeProfile from "components/Employee/EmployeeProfile";
import { userHasRight } from "selectors/rights";
import { EMPLOYEE_CONTACT_FULL_VIEW } from "typeConstants/rights";

const EmployeeList = ({ location, canViewEmployeeInfoFull }) => {
  const [employees, setEmployees] = useState();
  const [selectedEmployeeIndex, setSelectedEmployeeIndex] = useState();
  const mounted = useRef(true);

  useEffect(() => {
    searchEmployees(getSearchParameter(location) ?? "", setEmployees, mounted);
    return () => mounted.current = false;
  }, []);

  const onEmployeeSelected = i => setSelectedEmployeeIndex(i);
  
  const columns = canViewEmployeeInfoFull ? [
    { name: "Employee Id", dataSource: "employeeId", width: 130 },
    { name: "First Name", dataSource: "firstName", width: 140 },
    { name: "Last Name", dataSource: "lastName", width: 140 },
    { name: "Payroll Id", dataSource: "payrollEmployeeId", width: 130 },
    { name: "Role", dataSource: "role.name", width: 150 },
    { name: "Address", dataSource: "address.address1", width: 150 },
    { name: "City", dataSource: "address.city", width: 150 },
    { name: "State", dataSource: "address.state", width: 150 },
    { name: "Zip", dataSource: "address.zip", width: 150 },
  ].map(c => ({ ...c, key: c.name })) : [
    { name: "Employee Id", dataSource: "employeeId", width: 130 },
    { name: "First Name", dataSource: "firstName", width: 140 },
    { name: "Last Name", dataSource: "lastName", width: 140 },
    { name: "Payroll Id", dataSource: "payrollEmployeeId", width: 130 },
    { name: "Role", dataSource: "role.name", width: 150 },
  ].map(c => ({ ...c, key: c.name }));

  return (
    <MSplitter
      firstChild={
        <div className="padding-page-content full-height">
          <MGrid
            configurationId="EmployeeList"
            headerText="Employees"
            columnDefinitions={columns}
            data={employees}
            isFetchingData={!employees}
            onRowClick={onEmployeeSelected}
            displayNumOfItemsFound
            rowLastClicked={selectedEmployeeIndex}
          />
        </div>}
      secondChild={selectedEmployeeIndex >= 0 && <EmployeeProfile verticalDisplay employeeId={employees[selectedEmployeeIndex].employeeId} internetUserId={employees[selectedEmployeeIndex].internetUserId}/>}
    />
  );
};

EmployeeList.propTypes = {
  location: PropTypes.object,
  canViewEmployeeInfoFull: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    canViewEmployeeInfoFull: userHasRight(EMPLOYEE_CONTACT_FULL_VIEW)(state),
  };
};

export default connect(mapStateToProps)(EmployeeList);
